'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiClipboard = function TiClipboard(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.3 5h-16.6c-2.8 0-5 2.2-5 5v20c0 2.8 2.2 5 5 5h16.6c2.8 0 5-2.2 5-5v-20c0-2.8-2.2-5-5-5z m-13.3 3.3h10v1.7c0 0.9-0.7 1.7-1.7 1.7h-6.6c-1 0-1.7-0.8-1.7-1.7v-1.7z m15 21.7c0 0.9-0.7 1.7-1.7 1.7h-16.6c-1 0-1.7-0.8-1.7-1.7v-20c0-0.9 0.7-1.7 1.7-1.7h1.6v1.7c0 1.8 1.5 3.3 3.4 3.3h6.6c1.9 0 3.4-1.5 3.4-3.3v-1.7h1.6c1 0 1.7 0.8 1.7 1.7v20z m-3.3-1.7h-13.4c-0.4 0-0.8-0.3-0.8-0.8s0.4-0.8 0.8-0.8h13.4c0.4 0 0.8 0.3 0.8 0.8s-0.4 0.8-0.8 0.8z m0-5h-13.4c-0.4 0-0.8-0.3-0.8-0.8s0.4-0.8 0.8-0.8h13.4c0.4 0 0.8 0.3 0.8 0.8s-0.4 0.8-0.8 0.8z m0-5h-13.4c-0.4 0-0.8-0.3-0.8-0.8s0.4-0.8 0.8-0.8h13.4c0.4 0 0.8 0.3 0.8 0.8s-0.4 0.8-0.8 0.8z' })
        )
    );
};

exports.default = TiClipboard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/clipboard.js
// module id = 3585
// module chunks = 0